import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { addBulletin } from 'services/fund'

export default function useSetAddBulletin(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IAddBulletinPayload) => {
            return addBulletin(payload)
        },
        onSuccess: (data) => {
            toast.success('  با موفقیت اضافه یافت')
            refetch()
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { isLoading, mutate }
}
